import { render, staticRenderFns } from "./zshc.vue?vue&type=template&id=58b7b148&scoped=true&"
import script from "./zshc.vue?vue&type=script&lang=js&"
export * from "./zshc.vue?vue&type=script&lang=js&"
import style0 from "./zshc.vue?vue&type=style&index=0&id=58b7b148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7b148",
  null
  
)

export default component.exports